/** EMPTY_TAG is allowed for all VRs except Pixel Data (protected by default). */

const PIXEL_DATA_TAG_KEY = '7FE00010'

export const normalizeDicomTagKey = (tagId?: string | null): string => {
  if (!tagId) return ''
  return tagId.replace(/[^0-9A-Fa-f]/g, '').toUpperCase()
}

export const isPixelDataTag = (tagId?: string | null): boolean => normalizeDicomTagKey(tagId) === PIXEL_DATA_TAG_KEY

export const getVrAbbreviation = (
  valueRepresentation?: string | { abbreviation?: string } | null,
): string | undefined => {
  if (!valueRepresentation) return undefined
  if (typeof valueRepresentation === 'string') return valueRepresentation
  return valueRepresentation.abbreviation
}

export const isEmptyTagAllowed = (tagId?: string | null): boolean => {
  return !isPixelDataTag(tagId)
}
